import { render, staticRenderFns } from "./SKCollapse.vue?vue&type=template&id=07d24467&"
import script from "./SKCollapse.vue?vue&type=script&lang=js&"
export * from "./SKCollapse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports